import { React, useEffect, useRef, useState } from 'react';

export const ButtonLoading = () => {
      return(
            <div className='button_loading'></div>
      );
}